// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PdfTemplatesService } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';
import { GetTemplateFormatList } from './template-format.actions';
import { TEMPLATE_FORMAT_STATE_DEFAULT, TemplateFormatStateModel } from './template-format.model';

@State({ name: 'TemplateFormat', defaults: TEMPLATE_FORMAT_STATE_DEFAULT })
@Injectable()
export class TemplateFormatState {

  constructor(private pdfTemplateService: PdfTemplatesService) {
  }

  @Selector()
  static formatList(state: TemplateFormatStateModel): TemplateFormatStateModel['formatList'] {
    return state.formatList;
  }

  @Selector()
  static loadFormatsStatus(state: TemplateFormatStateModel): TemplateFormatStateModel['loadFormatsStatus'] {
    return state.loadFormatsStatus;
  }

  @Action(GetTemplateFormatList)
  getTemplateFormatList(ctx: StateContext<TemplateFormatStateModel>): void {
    ctx.patchState({
      loadFormatsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.pdfTemplateService.getTemplateFormatList()
      .subscribe({
        next: (formatList) => {
          ctx.patchState({
            formatList,
            loadFormatsStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: () => {
          ctx.patchState({
            loadFormatsStatus: PROGRESS_STATUSES.FAIL
          });
        }
      });
  }
}


